export enum Shadow {
	Dropdown = `0px 9px 14px 0px #3f576d0d`,
	Large = '0px 4px 34px 0px rgba(63, 87, 109, 0.24)',
}
